// src/pages/Reset Password/ResetPassword.tsx

import React, { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import styled from 'styled-components';
import { ResetPasswordForm } from '../../components/auth';
import { ResetPasswordFormData } from '../../components/auth/resetPasswordTypes';

const ResetPasswordContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 2rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ResetPassword: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isValidSession, setIsValidSession] = useState(false);

  useEffect(() => {
    // Check if we have a valid recovery session
    const checkSession = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Session error:', error);
          setError('Invalid or expired reset link. Please request a new password reset.');
          return;
        }

        if (session?.user) {
          setIsValidSession(true);
        } else {
          setError('Invalid or expired reset link. Please request a new password reset.');
        }
      } catch (err) {
        console.error('Session check error:', err);
        setError('Invalid or expired reset link. Please request a new password reset.');
      }
    };

    checkSession();
  }, []);

  const handlePasswordReset = async (formData: ResetPasswordFormData) => {
    setLoading(true);
    setError('');

    try {
      const { error } = await supabase.auth.updateUser({
        password: formData.password
      });

      if (error) {
        throw error;
      }

      setSuccess(true);
    } catch (err: any) {
      console.error('Password reset error:', err);
      setError(err.message || 'Failed to update password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!isValidSession && !error) {
    return (
      <ResetPasswordContainer>
        <div style={{ 
          textAlign: 'center', 
          color: '#6c757d',
          fontSize: '1.1rem'
        }}>
          Verifying reset link...
        </div>
      </ResetPasswordContainer>
    );
  }

  return (
    <ResetPasswordContainer>
      <ResetPasswordForm
        onSubmit={handlePasswordReset}
        loading={loading}
        error={error}
        success={success}
      />
    </ResetPasswordContainer>
  );
};
